import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxXmlToJsonService } from './ngx-xml-to-json.service';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';
import { UserMessageService } from './user-message.service';
import { DataLayerPNGComponent } from './data-layer-png.component';

declare var L;

/*
 * data-layer-png-rainviewer defines a class to display png layers from https://www.rainviewer.com/api.html
 * This gets its own class because a list of available time-stamped images must be retrieved in order
 * to create the retrieval url.  By default, only the most recent radar image is displayed; however, if "loop" is set
 * to true, all available images are displayed.
 *  
 * Images are 10 minutes apart.  10 images represents 1.5 hours of weather radar data.
 *
 * Within the configuration file, rainviewer png layers can be included:
 * "overlayLayers": [
 * 		{"id": "radarLayerRainviewerLoop", "label": "Rainviewer Radar (loop)",
 * 			"url": "https://tilecache.rainviewer.com/v2/radar/{timestamp}/256/{z}/{x}/{y}/5/1_1.png",
 *			"class": "data-layer-png-rainviewer",
 *			"loop": true,
 *			"refresh": true },
 * ...
 * ]
 *
 */

@Component({
	selector: 'data-layer-ca-qpf',
	standalone: false,
	template: `
		<div class="checkboxDiv"><label class="overlay-layer" title={{titleString}}>
		<input type="checkbox" title={{titleString}} (click)="menuControlSelected($event)">{{htmlElementLabel}}</label>
		<app-single-legend [active]=active [legendUrl]=legendUrl></app-single-legend>
		</div>
		`,
	styleUrls: ['app.component.css']
})

export class DataLayerCaQPFComponent extends DataLayerPNGComponent {

	ngxXmlToJsonService;
	latLngBounds = [[32.5, -124.48], [43.375, -114.105]];	// default SW, NE corners of png

	constructor(
		mapService: MapService,
		dataLayerService: DataLayerService,
		configService: ConfigService,
		userMessageService: UserMessageService,
		http: HttpClient,
		ngxXmlToJsonService: NgxXmlToJsonService ) {

		super(mapService, dataLayerService, configService, userMessageService, http);
		this.ngxXmlToJsonService = ngxXmlToJsonService;
       }

       // first check whether the information has been read.
	// display the markers on the map and set the layer to active
	activateLayer () {
		console.log('Activating ' + this.id + ' layer.');
		if ( this.mapLayer != null ) {
			this.mapService.map.removeLayer(this.mapLayer);
		}
		if ( this.value == null || this.refresh === true ) {
			// once the data file has been read, drawMarkers is automatically called because an observer has been established
			this.parseDataFile();
		}
        // console.log(this);

		// const imageUrl = 'http://www.cnrfc.noaa.gov/data/kml/72hr_QPF_1.png';
		// const imageBounds = [[32.5, -124.48], [43.375, -114.105]];
		// this.mapLayer = L.imageOverlay(imageUrl, imageBounds, { opacity: this.opacity}).addTo(this.mapService.map);
		else {
			console.log(this.value, this.latLngBounds);
			// this.mapLayer = L.imageOverlay(this.value, this.latLngBounds, { opacity: this.opacity}).addTo(this.mapService.map);
			this.display();
		}

		this.active = true;
    }

	display() {

		this.mapLayer = L.imageOverlay(this.value, this.latLngBounds, { opacity: this.opacity}).addTo(this.mapService.map);
		// activate legend as well
		const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		if ( legendDisplay != null ) {
			legendDisplay['source'].next (true);
		}
	}
	parseDataFile () {
		console.log('In data-layer-png.parseDataFile.');
		if ( this.url.startsWith('http')) {
			const self = this;

			this.http.get(this.url, { 'responseType': 'text'})
				.subscribe ( kmlFile => {
						const options = {};
						const jsonContents = self.ngxXmlToJsonService.xmlToJson( kmlFile, options );
						// console.log(jsonContents);
						this.titleString = jsonContents.kml.Folder?.name?.text;
						this.value = jsonContents.kml.Folder?.GroundOverlay?.Icon?.href?.text;
						const latLonBox = jsonContents.kml.Folder?.GroundOverlay?.LatLonBox;
						console.log(this.value);
						if ( latLonBox == null ) { 
							console.log("Problem with kml format - no LatLonBox"); 
						} else {
							const vertSW = L.latLng(latLonBox.south.text, latLonBox.west.text);
							const vertNE= L.latLng(latLonBox.north.text, latLonBox.east.text);
							this.latLngBounds = L.latLngBounds(vertSW, vertNE);
							// console.log(this.latLngBounds);
							this.display();
						}
				});
		} else {
			this.value = this.configService.baseDir + this.url + '?nocache=' + (new Date()).getTime();
						this.mapLayer = L.imageOverlay(this.value, this.latLngBounds, { opacity: this.opacity}).addTo(this.mapService.map);
			this.display();
		}
	}

    }
